import React, { useState } from 'react';
import {
    Block,
    TextDefault,
    SpaceBetweenDiv,
    Heading3,
    Heading4,
} from '@awarego-ui/components';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { ThemedDropdownItem } from '../../../../components/themed/ThemedComponents';
import { observer } from 'mobx-react';
import { useAssessmentType } from '../../useAssessmentType';

function CompletedAssessment({
    HugeHeading,
    editingAssessment,
    hasStarted,
    isScorm = false,
}) {
    const [employeesDropdown, setEmployeesDropdown] = useState(false);
    const toggleEmployeesDropdown = () => {
        setEmployeesDropdown(!employeesDropdown);
    };

    const {userNamePlural, userNamePluralTitle, name, assessmentUsersStoresFactory, isAssessmentInsight} = useAssessmentType()


    const showFinishedEmployees = () => {
        assessmentUsersStoresFactory.showEmployeesModal('users', {
            isFinished: true,
            subheading: `${userNamePluralTitle} who completed the ${name}`,
            scoreName: 'Resilience score',
        });
    };

    const showNotStartedEmployees = () => {
        assessmentUsersStoresFactory.showEmployeesModal('users', {
            isStarted: false,
            subheading: `${userNamePluralTitle} who didn't start the ${name}`,
            scoreName: 'Resilience score',
        });
    };

    const showNotFinishedEmployees = () => {
        assessmentUsersStoresFactory.showEmployeesModal('users', {
            isStarted: true,
            isFinished: false,
            subheading: `${userNamePluralTitle} who didn't complete the ${name}`,
            scoreName: 'Resilience score',
        });
    };

    return (
        <Block resetMargin gap={16}>
            <Heading3>
                {isScorm || isAssessmentInsight
                    ? `${userNamePluralTitle} who completed the assessment`
                    : 'Completed the assessment'}
            </Heading3>
            <HugeHeading lighter={!hasStarted}>
                {isScorm || isAssessmentInsight
                    ? editingAssessment._rawData.usersFinished
                    : `${editingAssessment.attendance}%`}
            </HugeHeading>
            {hasStarted ? (
                <SpaceBetweenDiv>
                    {!isScorm && (
                        <TextDefault bold lighter>
                            {editingAssessment._rawData.usersFinished}/
                            {editingAssessment._rawData.usersTotal} {userNamePlural}
                        </TextDefault>
                    )}

                    <Dropdown
                        isOpen={employeesDropdown}
                        toggle={toggleEmployeesDropdown}
                    >
                        <TextDefault
                            bold
                            themed
                            flex
                            link
                            onClick={() =>
                                isScorm ? showFinishedEmployees() : undefined
                            }
                        >
                            {isScorm ? (
                                `View ${userNamePlural}`
                            ) : (
                                <DropdownToggle
                                    caret
                                    tag="span"
                                    onClick={() => toggleEmployeesDropdown}
                                >
                                    View {userNamePlural}{' '}
                                </DropdownToggle>
                            )}
                        </TextDefault>
                        {!isScorm && (
                            <DropdownMenu>
                                <ThemedDropdownItem
                                    onClick={showFinishedEmployees}
                                >
                                    {userNamePluralTitle} who completed the {name} (
                                    {editingAssessment._rawData.usersFinished})
                                </ThemedDropdownItem>
                                {!isAssessmentInsight && (
                                    <ThemedDropdownItem
                                        onClick={showNotStartedEmployees}
                                    >
                                        {userNamePluralTitle} who didn't start the {name} (
                                        {editingAssessment._rawData.usersTotal -
                                            editingAssessment._rawData.usersStarted})
                                    </ThemedDropdownItem>
                                )}
                                <ThemedDropdownItem
                                    onClick={showNotFinishedEmployees}
                                >
                                    {userNamePluralTitle} who didn't complete the {name} (
                                    {(isAssessmentInsight ? editingAssessment._rawData.usersTotal : editingAssessment._rawData.usersStarted) -
                                        editingAssessment._rawData.usersFinished})
                                </ThemedDropdownItem>
                            </DropdownMenu>
                        )}
                    </Dropdown>
                </SpaceBetweenDiv>
            ) : (
                <Heading4 center lighter>
                    No completion rate yet
                </Heading4>
            )}
        </Block>
    );
}

export default observer(CompletedAssessment);
